import axios from 'axios';
import { API_END_POINT } from 'configs/configs';
import AuthUser from './auth';

 class PatientsModel {

  /* send Request to the API endpoint
   *   return request promise
   */
  async sendRequest(endpoint, params = null, method = 'GET') {
    try {
      let currentUserToken = AuthUser.getToken();
      let response = await axios({
        // Endpoint to send files
        url: endpoint,
        method: method,
        params,
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${currentUserToken}`,
        },
      });
     
      if (Number(response.data.error) !== 0 && response.data.error!== undefined) {
      
        return Promise.reject(response);
      }
   
      return Promise.resolve(response.data.results);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getPatients({ page=1,search=false }) {
    if(!search){
      return this.sendRequest(API_END_POINT.PATIENTS,{page});
    }else{
      return this.sendRequest(API_END_POINT.PATIENTS,{page,q:search });
    }
  }
}

PatientsModel = new PatientsModel();
export default PatientsModel ;